/** Titres des cartes Bâtir Pro pour le tableau global commentaires (sync Prisme_Modele). */
export const batirProFeedbackCardTitles: { id: number; title: string }[] = [
  { id: 1, title: 'Gouvernance du comité TI' },
  { id: 16, title: 'Gouvernance TI 2026 — cadre PRIsME' },
  { id: 2, title: 'Comité TI Bâtir Pro x BZ' },
  { id: 3, title: 'Liste des besoins – Bâtir Pro' },
  { id: 12, title: 'Tableau de présentation prise de besoin client 2026' },
  { id: 4, title: 'Cadre référentiel BZ — construction 4.0' },
  { id: 18, title: 'Cadre référentiel PRIsME avancé' },
  { id: 5, title: 'Roadmap technologique 2026 – gestion de projets 4.0' },
  { id: 15, title: 'Plan budgétaire 5 ans (ODS support & gestion TI)' },
  { id: 7, title: 'Documents stratégiques Bâtir Pro' },
  { id: 11, title: 'Liste des documents créés – Bâtir Pro' },
  { id: 14, title: 'Tableau de bord cyber' },
  { id: 13, title: 'Catalogue des actifs TI' },
  { id: 8, title: 'Parties prenantes & tableau de bord compétences' },
  { id: 9, title: 'Panorama PRIsME – tableau de bord chantier 360°' },
  { id: 10, title: 'Assistant prise de besoins — construction & BIM' },
];
